import React from 'react'
import { useState } from "react"
import * as toastr from "toastr"

import Loader from "Placements/Components/Loader"
import API from "Placements/API"

import * as iconBack from 'Placements/Assets/img/icon/arrow-back-purple.png'

const Formulario = () => {

    const [userName, setUserName] = useState("")
    const [isLoading, setLoading] = useState(false)

    const handleForgetPassword = async (e: any) => {
        e.preventDefault();
        setLoading(true)

        try {
            const responseAuth = await API.Auth.ForgotPassword({ email: userName })
            const { data } = responseAuth

            if (data && data.enviouEmail) {
                toastr.success('Sua solicitação foi realizada com sucesso, em instantes você receberá a orientação para realizar a troca da sua senha.', '')
                window.location.href = "#/login"
            } else if (data && data.emailExistente === false) {
                toastr.error("O e-mail informado não está cadastrado na base. Informe um e-mail válido.", '')
            } else {
                toastr.error("Não foi possível realizar esta ação.", '')
            }
        } catch (erro) {
            toastr.error("Não foi possível realizar esta ação.", '')
        } finally {
            setLoading(false)
        }
    }


    return (
        <div className="form-login">
            {isLoading && <Loader />}
            <div className="top">
                <a href="#/login">
                    <img src={iconBack} />
                </a>
            </div>
            <div>
                <h3 className="form-title">Oops, I forgot it...</h3>
                <p className="form-txt">Esqueceu a senha? Sem problemas, nos informe seu email que te enviaremos um link para definir uma nova senha :D</p>

                <form onSubmit={handleForgetPassword} >
                    <input
                        id="username"
                        name="username"
                        type="email"
                        className="form-input"
                        placeholder="Qual é seu email?"
                        onChange={(e: any) => setUserName(e.target.value)}
                        autoComplete="on"
                    />
                    <input
                        type="submit"
                        className="form-btn btn"
                        value="Recuperar senha"
                        disabled={userName == null || userName == ""}
                    />
                </form>
            </div>
        </div>
    )
}

export default Formulario
